/**
 * SaMobileBottomNav (R60.49) — Bottom navigation mobile per SA/Consulente.
 *
 * Fixed bottom bar visibile solo su schermi <lg (dove SaDrawer diventa Sheet).
 * 5 slot: shortcuts alle pagine SA più utilizzate + pulsante Menu (apre il drawer).
 * Ereditato dal SaDrawer che espone un evento globale per aprire lo Sheet.
 */
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Building2, FileText, FileSignature, Briefcase, Menu } from "lucide-react";

const SA_TABS = [
  { to: "/aziende",    label: "Aziende",   icon: Building2 },
  { to: "/contratti",  label: "Contratti", icon: FileSignature },
  { to: "/report",     label: "Report",    icon: FileText },
  { to: "/assistenza-admin", label: "Ticket", icon: Briefcase },
];

export default function SaMobileBottomNav() {
  const { user } = useAuth();
  const loc = useLocation();
  if (user?.role !== "superadmin" && user?.role !== "consultant") return null;

  const openDrawer = () => {
    // Simula il click sul FAB del drawer (unico entry-point per il Sheet)
    document.querySelector('[data-testid="sa-drawer-open"]')?.click();
  };

  return (
    <nav
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-slate-200 shadow-[0_-4px_16px_rgba(19,41,75,0.06)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0)" }}
      data-testid="sa-mobile-bottom-nav"
    >
      <div className="grid grid-cols-5 h-14">
        {SA_TABS.map((t) => {
          const Icon = t.icon;
          const active = loc.pathname === t.to || loc.pathname.startsWith(t.to + "/");
          return (
            <Link
              key={t.to}
              to={t.to}
              className={`flex flex-col items-center justify-center gap-0.5 text-[10px] font-semibold transition ${
                active ? "text-amber-600" : "text-slate-500 hover:text-slate-800"
              }`}
              data-testid={`sa-mn-${t.to.slice(1)}`}
            >
              <Icon className={`w-4 h-4 ${active ? "text-amber-600" : "text-slate-400"}`} />
              <span>{t.label}</span>
              {active && <span className="absolute top-0 h-0.5 w-8 bg-amber-500 rounded-b" />}
            </Link>
          );
        })}
        <button
          type="button"
          onClick={openDrawer}
          className="flex flex-col items-center justify-center gap-0.5 text-[10px] font-semibold text-slate-500 hover:text-slate-800"
          data-testid="sa-mn-menu"
        >
          <Menu className="w-4 h-4 text-slate-400" />
          <span>Menu</span>
        </button>
      </div>
    </nav>
  );
}
